import { SandboxMessageType } from '@web-studio/shared-schemas';
import { resolveShellPostMessageTarget } from '@/bridge/shellOrigin';

export function postPageSelectToShell(pageId: string, slug: string): void {
  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      type: SandboxMessageType.PAGE_SELECT,
      pageId,
      slug,
    },
    resolveShellPostMessageTarget(),
  );
}
